import React, { useEffect, useState } from 'react';

const SelectRowColumn = ({ value, handleSelect, selectedRows }) => {
  const [checkValue, setCheckValue] = useState(false);
  useEffect(() => {
    const isInitiallySelected = selectedRows.some((row) => row.id === value);
    setCheckValue(isInitiallySelected);

    // Ako je red inicijalno selektovan, pozivamo handleSelect da reflektujemo promenu u tabeli
    if (isInitiallySelected) {
      handleSelect(value, true);
    }
  }, [selectedRows, value, handleSelect]);

  const handleClick = () => {
    setCheckValue((curr) => !curr);
    handleSelect(value, !checkValue);
    // console.log(value);
  };
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
      }}
      onClick={() => {
        handleClick(value);
      }}
    >
      <input
        type="checkbox"
        onChange={() => {}}
        checked={checkValue}
        style={{
          transform: 'scale(1.4)', // Povećava checkbox za 50%
          margin: '5px',
          cursor: 'pointer',
        }}
      />
    </div>
  );
};
export default SelectRowColumn;
